import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  tileLocationBreakdownWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  shortWrapper: {
    maxWidth: '176px',
    minWidth: '176px',
  },
  section: {
    gap: '20px',
    display: 'flex',
  },
}));
